/**
 * What bulk promotion is configured to accept, and how those values are shown.
 *
 * Fixed rather than fetched: the types are those with a last-modified resolver, which is what
 * promotion's idempotency check needs, and the cap was never tuned. GetBulkPromotionConfig used to
 * carry both — a round trip at page load for values a constant already knew, and a dropdown that
 * could disagree with the server. The enforcing copies are in BulkPromotionSubmitComponent.java.
 */

/** Must match BULK_PROMOTABLE_TYPES in BulkPromotionSubmitComponent.java. */
export const BULK_PROMOTABLE_TYPES: string[] = [
    'CLI_CONFIG',
    'PLI_CONFIG',
    'MDA_SHEET',
    'MDA_WORKSHEET',
    'TPA_TEMPLATE',
    'TPA_WORKSHEET',
];

/** Largest batch the API accepts. Must match BATCH_CAP in BulkPromotionSubmitComponent.java. */
export const BULK_PROMOTE_BATCH_CAP = 2000;

/** Display label per type. Shared by the submit dropdown and the history table. */
export const BULK_PROMOTE_TYPE_LABELS: Record<string, string> = {
    CLI_CONFIG: 'CLI',
    PLI_CONFIG: 'PLI',
    TPA_TEMPLATE: 'TPA Template',
    TPA_WORKSHEET: 'TPA Worksheet',
    MDA_SHEET: 'MDA Sheet',
    MDA_WORKSHEET: 'MDA Worksheet',
};

/** Falls through to the raw token, so a type a newer service accepts still renders. */
export function getBulkPromoteTypeLabel(componentType: string): string {
    return BULK_PROMOTE_TYPE_LABELS[componentType] || componentType;
}
